import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 101 70",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M34.998 9.003H5.002A5.001 5.001 0 0 0 0 14.002 5 5 0 0 0 5.002 19h17.922L1.466 40.467a4.996 4.996 0 0 0-1.083 5.447A5.004 5.004 0 0 0 5.005 49h18.987a5 5 0 0 0 5.002-4.999 5 5 0 0 0-5.002-4.999h-6.919l21.462-21.466A5 5 0 0 0 34.995 9l.003.003Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#00F0FA",
	d: "M34.999 48.997a5 5 0 0 0 5.002-5A5 5 0 0 0 34.999 39a5 5 0 0 0-5.002 4.999A5 5 0 0 0 35 48.997Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#00F0FA",
	d: "M50.004 10a5 5 0 0 0 5.002-4.998A5 5 0 0 0 50.004.003a5 5 0 0 0-5.002 4.999 5 5 0 0 0 5.002 4.999Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M95.556 45.263a5.003 5.003 0 0 0-5.504 4.445 10.336 10.336 0 0 1-7.514 8.9 10.352 10.352 0 0 1-11.063-3.661 5.006 5.006 0 0 0-7.016-.913 4.999 4.999 0 0 0-.914 7.012c3.94 5.114 9.897 7.964 16.115 7.964 1.857 0 3.738-.256 5.592-.777 8.073-2.277 13.858-9.135 14.745-17.47a5.003 5.003 0 0 0-4.447-5.5h.006Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M97.063 18.537a4.994 4.994 0 0 0-2.095-9.532H80.022c-11.033 0-20.01 8.972-20.01 19.998 0 11.027 8.977 19.999 20.01 19.999 11.033 0 20.01-8.972 20.01-19.999 0-3.833-1.085-7.418-2.966-10.463l-.003-.003ZM80.019 38.998c-5.518 0-10.004-4.486-10.004-9.998 0-5.511 4.489-9.997 10.004-9.997S90.023 23.489 90.023 29c0 5.512-4.489 9.998-10.004 9.998ZM50.004 10.943a5 5 0 0 0-5.002 5v28.056a5 5 0 0 0 5.002 5 5.001 5.001 0 0 0 5.002-5V15.942c0-2.76-2.24-4.999-5.002-4.999Z"
}));
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
